import React, { useState } from 'react'
import { useGlobal } from '@jimmyboys/liita-ui/dist/components/GlobalContext'
import VStack from '@jimmyboys/liita-ui/dist/components/VStack'

import SegmentedControl from '@jimmyboys/liita-ui/dist/components/SegmentedControl'
import EditAppointmentProtocolDialog from './EditAppointmentProtocolDialog'
import EditMedicalActProtocolDialog from './EditMedicalActProtocolDialog'

import styles from './../../Dialog.module.sass'
import toBool from 'utils/toBool'

export const APPOINTMENT_PROTOCOLS = toBool(
	window.REACT_APP_APPOINTMENT_PROTOCOLS ||
	process.env.REACT_APP_APPOINTMENT_PROTOCOLS
)
export const MEDICAL_ACT_PROTOCOLS = toBool(
	window.REACT_APP_MEDICAL_ACT_PROTOCOLS ||
	process.env.REACT_APP_MEDICAL_ACT_PROTOCOLS
)

const renderSelectedTab = (selectedTab, processId, accidentType, postalCode, dismiss, resolve) => {
	switch (selectedTab) {
		case 'appointments':
			return (
				<EditAppointmentProtocolDialog
					data={{ processId }}
					dismiss={dismiss}
					resolve={resolve}
				/>
			)
		case 'medicalActs':
			return (
				<EditMedicalActProtocolDialog
					data={{ processId, accidentType, postalCode }}
					dismiss={dismiss}
					resolve={resolve}
				/>
			)
		default:
			return <div />
	}
}

const EditProcessProtocolDialog = (props) => {
	const { data, dismiss, resolve } = props
	const { processId, accidentType, postalCode } = data
	const { i18n } = useGlobal()
	const tabs = [
		APPOINTMENT_PROTOCOLS && {
			id: 'appointments',
			text: i18n`Appointments`,
		},
		MEDICAL_ACT_PROTOCOLS && {
			id: 'medicalActs',
			text: i18n`Medical Acts`,
		},
	].filter(Boolean)
	const [selectedTab, setSelectedTab] = useState(tabs[0].id)
	return (
		<VStack className={styles['protocols-root']}>
			<SegmentedControl
				className={styles['protocols-segment-control']}
				selectedTab={selectedTab}
				onSelect={(e) => {
					setSelectedTab(e.id)
				}}
				selectorType={'border'}
				tabs={tabs}
			/>
			{renderSelectedTab(selectedTab, processId, accidentType, postalCode, dismiss, resolve)}
		</VStack>
	)
}

export default EditProcessProtocolDialog
